export const tracking = {
	selector: {
		carousel: '.js-tracking-carousel',
		carouselHandle: 'data-carousel-handle',
		adId: 'data-ad',
		trackingSelectHandle: 'data-tracking-select-handle',
		campaignSelect: '.js-tracking-select-campaign',
	},
}
